import { Transform } from 'class-transformer';
import { IsEnum, IsOptional } from 'class-validator';
import { CampaignBlastStatusesEnum, CampaignBlastTypesEnum, CampaignAudienceTypeEnum } from '../../enums';
import { OrderParamPair } from '../../interfaces/filters/order-param-pair';
import { OrderFilter } from '../../interfaces/filters/order.filter';
import { SearchFilter } from '../../interfaces/filters/search.filter';
import { arrayOrStringToArray, jsonStringToObject } from '../../types-transformers';
import { CampaignBlastDto, UserDto } from '../dto';
import { PaginationFilter } from '../../interfaces/filters/pagination.filter';

export class CampaignBlastFilter implements SearchFilter, OrderFilter<CampaignBlastDto>, PaginationFilter {
	@Transform(arrayOrStringToArray)
	@IsEnum(CampaignBlastStatusesEnum, { each: true })
	@IsOptional()
	statuses?: CampaignBlastStatusesEnum[] | undefined;

	@IsEnum(CampaignBlastTypesEnum)
	@IsOptional()
	blastType?: CampaignBlastTypesEnum | undefined;

	@Transform(arrayOrStringToArray)
	@IsEnum(CampaignAudienceTypeEnum, { each: true })
	@IsOptional()
	audienceTypes?: string[] | undefined;

	search?: string;

	@Transform(jsonStringToObject)
	orderedBy?: OrderParamPair<CampaignBlastDto>[] | null;

	pageSize?: number | null;
	page?: number | null;
}

export class CampaignUsersFilter implements OrderFilter<UserDto>, PaginationFilter {
	@Transform(jsonStringToObject)
	orderedBy?: OrderParamPair<UserDto>[] | null;

	pageSize?: number | null;
	page?: number | null;
}
